import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
import Carousel from "./component/Carousel";
import 'animate.css';

const Home = () => {

    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.unobserve(el); // stop observing once it’s in view
                }
            },
            { threshold: 0.1 } // fire when 10% of the h1 is visible
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <Layout>


            <section className='courasel'>
                <Carousel />
            </section>


            <section className='child-container'>
                <div className='dflex gap-5 align-items-end pt-5'>
                    <div className='secOne'>
                        <h1 className="wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">We Deliver High-Standard Services and Products</h1>
                    </div>
                    <div className='secTwo'>
                        <p className="paragraph-title wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">The company is committed to delivering high-quality, reliable, and cost-effective services to ensure operational efficiency and workplace safety in the energy sector.</p>
                        <div className='lineOne  wow animate__animated animate__fadeInLeft' data-wow-duration="1.5s" />
                    </div>

                </div>
            </section>


            <section className='child-container'>
                <div className='sectionTwo'>
                    <Image src="/HomeDiv.png" className="d-inline-block  img-fluid wow animate_animated animate__fadeInUp"
                        data-wow-duration="1.5s" alt="inovative" />
                </div>
            </section>


            <section className='sectionThree'>
                <div className='child-container'>
                    <div className='sectionInner'>
                        <div className='secThreeOne'>
                            <p className="paragText wow animate__animated animate__fadeInUp" data-wow-duration="0.8s">OUR VALUES</p>
                        </div>
                        <div className="secThreeTwo wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">
                            <h1>We put our customers first through<br className='hide' />  reliable, value-added services that foster long-term partnerships.</h1>
                            {/* <p className='paragText wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>The company is committed to delivering high-quality, reliable, and cost-effective services to ensure operational efficiency and workplace safety in the energy sector.</p> */}

                        </div>
                    </div>

                    <div className='sectionInnerTwo'>
                        <div className='list-box wow animate__animated animate__fadeInUp' data-wow-duration='1s'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Customer Satisfaction</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>01</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Build strong relationships by delivering reliable, efficient, and customer-focused solutions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='list-box wow animate__animated animate__fadeInUp'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Drive Innovation</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>02</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Continuously improve our services through creative and forward-thinking solutions that meet evolving industry needs.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div className='sectionInnerTwo'>
                        <div className='list-box wow animate__animated animate__fadeInUp'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Integrity</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>03</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We uphold and maintain transparency, honesty, and ethical business practices in all our operations.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='list-box wow animate__animated animate__fadeInUp'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Safety & Sustainability</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>04</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Prioritize the well-being of people and the environment through responsible and sustainable business practices.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </section>


            {/* <section className='sectionFour'>
                <div className='child-container'>

                   <h1>INDUSTRIES<br className='hide' />  WE SERVE</h1>

                   <div className='row w-100'>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                             <FaCheckCircle className='checkBox'/> Energy, Oil & Gas</h4>
                    </div>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                          <FaCheckCircle className='checkBox'/> Construction and Engineering</h4>
                    </div>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                          <FaCheckCircle className='checkBox'/> Manufacturing</h4>
                    </div>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                          <FaCheckCircle className='checkBox'/> Government and Public Sector</h4>
                    </div>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                          <FaCheckCircle className='checkBox'/> Health Care</h4>
                    </div>
                    <div className='col-lg-6'>
                          <h4 className='serve-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>
                          <FaCheckCircle className='checkBox'/> Corporate and Commercial Enterprises</h4>
                    </div>
                   </div>


                </div>
            </section> */}

        </Layout>
    );
};

export default Home;